// 내 문의 현황 · 내 대화 기록 공통 조각
import React from "react";
import { useMyText } from "./text";
import { bizFmt, fmtSchedule, stepIndex, STATUS_CLASS } from "./format";
import { useLanguage } from "../../i18n/LanguageContext";

export function PageTop({ title, desc, customer, onBack }) {
    const tt = useMyText();
    return (
        <div className="my-top">
            <button type="button" className="my-back" aria-label={tt("back")} onClick={onBack}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true"><path d="M15 18l-6-6 6-6" /></svg>
            </button>
            <div className="my-top-t"><h2>{title}</h2>{desc && <p>{desc}</p>}</div>
            {customer && <div className="my-top-store"><b>{customer.business_name}</b><span>{bizFmt(customer.business_number || "")}</span></div>}
        </div>
    );
}

export function StatusTag({ status }) {
    const tt = useMyText();
    return <span className={`my-tag ${STATUS_CLASS[status] || ""}`}>{tt(`st.${status}`)}</span>;
}

export function ChannelTag({ channel }) {
    const tt = useMyText();
    return channel ? <span className={`my-tag ch-${channel}`}>{tt(`ch.${channel}`)}</span> : null;
}

// 3단계(접수·처리 중·완료) — 보류·취소는 그리지 않는다
export function Steps({ status, large }) {
    const tt = useMyText();
    const idx = stepIndex(status);
    if (idx < 0) return null;
    return (
        <div className={`my-steps ${large ? "lg" : ""}`}>
            {["new", "processing", "completed"].map((k, i) => (
                <div key={k} className={`my-stp ${i <= idx ? "on" : ""} ${i === idx ? "cur" : ""}`}>
                    <div className="c">{(i < idx || status === "completed") && "✓"}</div>
                    <span>{tt(`st.${k}`)}</span>
                </div>
            ))}
        </div>
    );
}

// 처리 내용 — 완료면 「처리 결과」, 그 전 상태라도 담당자가 적어 두었으면 「처리 내용」으로 보인다
export function ResultNote({ item }) {
    const tt = useMyText();
    if (!item.process_content) return null;
    const done = item.status === "completed";
    return <div className={`my-note ${done ? "done" : "info"}`}><b>{tt(done ? "result" : "progress")}</b><div>{item.process_content}</div></div>;
}

// 카드·상세 공통 아래 줄: 접수 대기·담당·방문 예정 / 보류 / 취소(+사유) + 처리 내용
export function StateNote({ item, withResult = true }) {
    const result = withResult ? <ResultNote item={item} /> : null;
    return <><StateLine item={item} />{result}</>;
}

function StateLine({ item }) {
    const tt = useMyText();
    const { lang } = useLanguage();
    const names = (item.assignee_names || []).join(", ");
    if (item.status === "on_hold") return <div className="my-note hold">{tt("hold")}</div>;
    if (item.status === "canceled") {
        return <div className="my-note cancel"><div>{tt("canceled")}</div>{item.status_reason && <div className="sub">{item.status_reason}</div>}</div>;
    }
    if (item.status === "completed") return null;
    const when = fmtSchedule(item.schedule, lang);
    return (
        <div className="my-meta">
            {names ? <span>{tt("assignee", { names })}</span> : item.status === "new" && <span>{tt("wait")}</span>}
            {when && <span>{tt("visit", { when })}</span>}
        </div>
    );
}

// 읽는 중 · 실패(다시 시도) · 없음(목록으로)
export function LoadState({ state, onRetry, onList }) {
    const tt = useMyText();
    if (state === "loading") return <div className="my-empty" aria-busy="true">…</div>;
    if (state === "notfound") {
        return <div className="my-empty">{tt("notFound")}<div><button type="button" className="my-btn" onClick={onList}>{tt("toList")}</button></div></div>;
    }
    return <div className="my-empty">{tt("loadFail")}<div><button type="button" className="my-btn" onClick={onRetry}>{tt("retry")}</button></div></div>;
}
